import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { PROFILE_QUERY_KEYS } from "../../../Profiles/api/queryKeys";

import { createEntityBranches } from "../services/entityBranches.service";
import { AddEntityLocationsFormData } from "../types/entityBranches.types";

interface CreateEntityBranchesResponse {
  success: boolean;
  message: string;
}

export const useCreateEntityBranches = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation("entity", { keyPrefix: "entityProfileEdit" });
  return useMutation<CreateEntityBranchesResponse, Error, { data: AddEntityLocationsFormData; entityId: number }>({
    mutationFn: ({ data, entityId }) => createEntityBranches(data, entityId),
    onSuccess: () => {
      toast.success(t("entityBranchesCreatedSuccessfully"));
      queryClient.invalidateQueries({ queryKey: [...PROFILE_QUERY_KEYS.entityBranches()] });
    },
    onError: () => {
      toast.error(t("failedToCreateEntityBranches"));
    },
  });
};
